import SessionStandingSpaces from "./SessionStandingSpaces";

const BookingStandingSpaces = SessionStandingSpaces;

export default BookingStandingSpaces;
